<template>
  <div
    :class="[
      'organism neighborhoods-map',
      organism.contentTheme,
      organism.neighborhoodsMapLayout,
      organism.removeMargin,
      'container-' + organism.containerWidth,
    ]"
    :style="'background-color:' + organism.backgroundColor"
  >
    <div
      v-if="
        organism.neighborhoodsMapLayout === 'layout-2-col-map-content' ||
        organism.neighborhoodsMapLayout === 'layout-2-col-content-map'
      "
      class="mx-auto grid grid-cols-1 md:grid-cols-2 min-h-[400px]"
    >
      <div id="map-wrap" class="w-full h-[500px]">
        <div id="map" class="w-full h-full"></div>
      </div>
      <div
        :class="[
          organism.neighborhoodsMapLayout === 'layout-2-col-content-map'
            ? 'md:-order-1'
            : '',
          'content w-full max-w-full px-12 py-10 lg:py-20 lg:max-w-2xl',
        ]"
      >
        <h3 class="mb-3 theme-text-eyebrow">{{ organism.title2 }}</h3>
        <h2
          class="mb-5 text-[2.5rem] leading-[2.75rem] lg:text-5xl font-bold font-archer"
        >
          {{ organism.title1 }}
        </h2>
        <div
          class="mx-auto text-lg text-gray-500 description mb-9 max-w-screen-md font-arial leading-6"
          v-html="organism.description"
        ></div>
        <MoleculesButtons :buttons="organism" :button-colors="buttonColors" />
      </div>
    </div>
    <div
      v-else
      class="py-16 mx-auto text-center max-w-screen-lg layout-default"
    >
      <h3 class="px-8 mx-auto mb-3 lg:px-0 theme-text-eyebrow">
        {{ organism.title2 }}
      </h3>
      <h2
        class="px-8 mx-auto mb-8 text-[2.5rem] leading-[2.75rem] lg:px-0 lg:text-5xl font-bold font-archer"
      >
        {{ organism.title1 }}
      </h2>
      <div id="map-wrap" class="w-full h-[500px] md:h-[700px]">
        <div id="map" class="w-full h-full"></div>
      </div>
      <div
        class="px-8 mx-auto text-lg text-gray-500 lg:px-0 description mb-9 max-w-screen-md font-arial leading-6"
        v-html="organism.description"
      ></div>
      <div class="px-8 lg:px-0">
        <MoleculesButtons
          class="!justify-center"
          :buttons="organism"
          :button-colors="buttonColors"
        />
      </div>
    </div>
  </div>
</template>

<style>
.neighborhoods-map {
  .layout-default #map-wrap {
    @apply w-full aspect-[3/2] mb-12;
  }

  &.layout-2-col-map-content,
  &.layout-2-col-content-map {
    #map-wrap {
      @apply w-full h-full;
    }
    .buttons a {
      @apply leading-none py-3 text-[15px];
    }
  }

  &.light-text {
    @apply text-white;

    .description {
      @apply text-white;
    }
  }

  .gm-style-iw {
    @apply !max-h-fit;
    .gm-style-iw-d {
      @apply !max-h-fit;
    }
  }
}
</style>

<script setup>
import { storeToRefs } from "pinia";
const overview = useOverview();
overview.fetchOverview();
const { mapInfo } = storeToRefs(overview);

const props = defineProps({
  organism: Object,
});

const buttonColors = computed(() => {
  const buttonColorsArray = [];
  if (props.organism.button1Color) {
    buttonColorsArray.push(props.organism.button1Color);
  }
  if (props.organism.button2Color) {
    buttonColorsArray.push(props.organism.button2Color);
  }
  if (props.organism.button3Color) {
    buttonColorsArray.push(props.organism.button3Color);
  }
  return buttonColorsArray;
});

onMounted(() => {
  if (props.organism.containerWidth === "full-width") {
    addFullWidthSupport();
  }
  loadNeighborhoodsMap();
  updateNeighborhoodsMap(mapInfo);
});

watch(mapInfo, () => {
  updateNeighborhoodsMap(mapInfo);
});
</script>
